import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { UPDATE_USER, VALIDATE_USER, GET_USER_DETAILS } from './constants';
import { validateUserSaga, getUserDetailsSaga } from './sagas';

export const updateUser = (user) => {
  return createAction({
    type: UPDATE_USER,
    payload: user,
  });
};

export const validateUser = (onSuccess, onError) => {
  return createAction({
    type: VALIDATE_USER,
    meta: {
      onSuccess,
      onError,
      async: validateUserSaga,
    },
  });
};

export const getUserDetails = (uuid, onSuccess, onError) => {
  return createAction({
    type: GET_USER_DETAILS,
    payload: uuid,
    meta: {
      onSuccess,
      onError,
      async: getUserDetailsSaga,
    },
  });
};
